import { Directive } from '@angular/core';

@Directive({
  selector: '[napaIwoSelect]',
  standalone: true,
})
export class IwoSelectDirective {}
